import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type HasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type InitiativeModel from './initiative';
import type PersonModel from './person';
import type TfoModel from './tfo';

export default class WorkStreamModel extends Model {
  declare [Type]: 'workstream';
  @belongsTo('initiative', { inverse: 'workstreams', async: true })
  declare initiative: AsyncBelongsTo<InitiativeModel>;
  @belongsTo('person', { inverse: 'workstreams', async: true })
  declare author: AsyncBelongsTo<PersonModel>;
  @hasMany('tfo', { async: false, inverse: 'workstream' })
  declare tfos: HasMany<TfoModel>;
  @attr('string') declare title: string;
  @attr('number') declare position: number;
  // @attr('boolean', { defaultValue: false }) archived;

  get openTickets() {
    let count = 0;
    this.tfos?.forEach((tfo) => {
      const tfo_is_open = tfo.completed === false;
      if (tfo_is_open) count += 1;
    });
    return count;
  }

  get closedTickets() {
    let count = 0;
    this.tfos?.forEach((tfo) => {
      const tfo_is_closed = tfo.completed === true;
      if (tfo_is_closed) count += 1;
    });
    return count;
  }

  get totalTickets() {
    return this.tfos?.length;
  }
}
